import React from 'react';
import { bool, func, string } from 'prop-types';

import { noop } from '@ajaibid/utils';

import {
  styContainer,
  styToggleSwitch,
  styCheckbox,
  styLabel,
  styInner,
  stySwitch,
  styWithLabel,
  styText,
} from './style';

function ToggleSwitch({
  text,
  imgSrc,
  handleClick,
  isBorder,
  isLabel,
}) {
  return (
    <div className={styContainer({ isBorder })}>
      {
    isLabel && (
      <div className={styWithLabel}>
        <img src={imgSrc} alt="" />
        <span className={styText}>
          {text}
        </span>
      </div>
    )
  }

      <div className={styToggleSwitch}>
        <input
          type="checkbox"
          className={styCheckbox}
          name={text}
          id={text}
          onClick={handleClick}
        />
        <label className={styLabel} htmlFor={text}>
          <span className={`${styInner} inner`} />
          <span className={`${stySwitch} switch`} />
        </label>
      </div>
    </div>
  );
}

ToggleSwitch.propTypes = {
  imgSrc: string,
  isBorder: bool,
  isLabel: bool,
  handleClick: func,
  text: string,

};

ToggleSwitch.defaultProps = {
  imgSrc: '',
  isBorder: false,
  isLabel: false,
  handleClick: noop,
  text: '',
};

export default ToggleSwitch;
